export const routes = (id) => {
  const links = [
    { text: 'Overview', value: `/business_units/${id}/` },
    { text: 'Activities', value: `/business_units/${id}/activities/` },
  ];
  return links;
};



// WEBPACK FOOTER //
// ./src/containers/BusinessUnits/navigations.js